import { useQuery } from 'react-query';

import { Currency } from '~/features/internationalization/models/currency';
import { getViewerCurrency } from '~/features/internationalization/utils/get-viewer-currency';

import { getStandaloneProgramPrice } from '../controllers/get-standalone-program-price';

export function useStandaloneProgramPrice({
  currency = getViewerCurrency(),
  nodeKey,
  learningPlanKey,
}: {
  currency?: Currency;
  nodeKey?: string;
  learningPlanKey?: string;
}) {
  return useQuery(
    ['standalone-pricing', currency, nodeKey, learningPlanKey],
    () => {
      if (nodeKey) {
        return getStandaloneProgramPrice({ currency, nodeKey });
      } else if (learningPlanKey) {
        return getStandaloneProgramPrice({ currency, learningPlanKey });
      }
    },
    {
      enabled: Boolean(currency) && (Boolean(nodeKey) || Boolean(learningPlanKey)),
    }
  );
}
